"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isJSON = (inputStr) => {
    try {
        return JSON.parse(inputStr) && !!inputStr;
    }
    catch (e) {
        return false;
    }
};
exports.default = isJSON;
//# sourceMappingURL=isJSON.js.map